<template>
  <button
    :class="buttonClasses"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    @mousedown="pressed = true"
    @mouseup="handleClick"
  >
    <p class="">{{ label }}</p>
  </button>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'

interface Props {
  label: string
  active?: boolean
  hovered?: boolean
  dark?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits(['click', 'hover'])

const hovered = ref(false)
const pressed = ref(false)

watch(hovered, (newVal) => {
  if (newVal) {
    emit('hover')
  }
})

const buttonClasses = computed(() => {
  const base = 'flex items-center justify-center transition-2 bg-black/0 text-medium-semibold h-40'

  const statusMap: Record<'default' | 'hover' | 'active', string> = {
    default: 'border-b-[3px] border-primary-50/0 ' + (props.dark ? 'text-gray-30' : 'text-gray-50'),
    hover: 'border-b-[3px] border-primary-50/0 ' + (props.dark ? 'text-white' : 'text-gray-95'),
    active: 'border-b-[3px] border-primary-50 text-primary-50'
  }

  const state = props.active ? 'active' : hovered.value || props.hovered ? 'hover' : 'default'

  return [base, statusMap[state]].join(' ')
})

const handleClick = () => {
  pressed.value = false
  emit('click')
}
</script>
